"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M18 17V9h-2V7h3a1 1 0 011 1v10a1 1 0 01-1 1H1a1 1 0 01-1-1V8a1 1 0 011-1h3v2H2v8h16zM9 6H7c-.55 0-1-.45-1-1s.45-1 1-1h2V2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1V6z"];
//# sourceMappingURL=add-parent.js.map